module.exports = __webpack_public_path__ + "img/stock6.cd850a8f.png";